var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowToRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56851 7.00009L1.5581 13.0105L0.14389 11.5963L4.74008 7.00009L0.143891 2.4039L1.55811 0.989683L7.56851 7.00009Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8562 13.0001H11.8562L11.8562 1.00009H9.8562L9.8562 13.0001Z",
    fill: "#747474"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNTY4NTEgNy4wMDAwOUwxLjU1ODEgMTMuMDEwNUwwLjE0Mzg5IDExLjU5NjNMNC43NDAwOCA3LjAwMDA5TDAuMTQzODkxIDIuNDAzOUwxLjU1ODExIDAuOTg5NjgzTDcuNTY4NTEgNy4wMDAwOVoiIGZpbGw9IiM3NDc0NzQiLz4KPHBhdGggZD0iTTkuODU2MiAxMy4wMDAxSDExLjg1NjJMMTEuODU2MiAxLjAwMDA5SDkuODU2Mkw5Ljg1NjIgMTMuMDAwMVoiIGZpbGw9IiM3NDc0NzQiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };